module.exports = __webpack_public_path__ + "img/list.a9126530.png";